import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Button, Switch, XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'type': 'primary',
                'disabled': this.get('rerendering'),
                'ev-click': this.rerender,
                'children': this.get('rerendering') ? '重新渲染中...' : '重新渲染'
            }),
            _$ce(2, 'span', [
                _$ct('showCodeHeader: '),
                _$cc(Switch, {
                    'value': this.get('showCodeHeader'),
                    'ev-$change:value': this.setShowCodeHeader
                })
            ], 4)
        ], 4, 'xmarkdown-demo-basic-actions'),
        _$cc(XMarkdown, {
            'content': this.get('content'),
            'loading': this.get('loading'),
            'typing': this.get('typing'),
            'showCodeHeader': this.get('showCodeHeader')
        })
    ], 4, 'xmarkdown-demo-basic');
};